import { useAuthHeader } from "react-auth-kit";

function useAuthFetch() {
  const authHeader = useAuthHeader();
  const authHeaderValue = authHeader();

  return (url) =>
    fetch(`${process.env.REACT_APP_SERVER_URI}${url}`, {
      headers: { Authorization: authHeaderValue },
    }).then((res) => res.json());
}

export default useAuthFetch;
